import styled from "styled-components";
import {GamblingSessionMessageBaseBox} from "../../boxes/gambling-session-message.box";

export const GamblingSessionMessageBox = styled(GamblingSessionMessageBaseBox)`
  max-width: 250px;
  margin: 0 auto;
`;
